var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgPhoneMobile = function SvgPhoneMobile(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.43 24L6.57 24C5.03767 24 4 22.7056 4 21.3667L4 2.63334C4 1.47102 4.87866 0 6.57 0L17.43 0C18.9623 0 20 1.29431 20 2.63334L20 21.3667C20 22.6011 19.0276 24 17.43 24ZM6.57 22L17.43 22C17.73 22 18 21.7 18 21.3667L18 2.63334C18 2.26667 17.73 2 17.43 2L6.57 2C6.24 2 6 2.30001 6 2.63334L6 21.3667C6 21.7333 6.27 22 6.57 22Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 6C7 4.89543 7.89543 4 9 4L15 4C16.1046 4 17 4.89543 17 6V16C17 17.1046 16.1046 18 15 18H9C7.89543 18 7 17.1046 7 16L7 6ZM15 6L15 16L9 16L9 6L15 6Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13 20C13 20.5523 12.5523 21 12 21C11.4477 21 11 20.5523 11 20C11 19.4477 11.4477 19 12 19C12.5523 19 13 19.4477 13 20Z",
    fill: "black"
  })));
};
export { SvgPhoneMobile as ReactComponent };
export default __webpack_public_path__ + "static/media/phone-mobile.12e997e6.svg";